import { toast } from "react-toastify";
import {  fetcheditMidSessionFailure, fetcheditMidSessionSuccess } from "./reducer";
import { setEditSuccessMessage } from "../../toastMessage/action";
import {  MID_SESSION } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import {  getMidSession } from "../thunk";

export const editMidSession = (jsonObj,eventType, setLoading,setModalOpen) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${MID_SESSION}/${eventType}`, 'PUT', jsonObj).then((response) => {
        if (response.error) {
            dispatch(fetcheditMidSessionFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
        if (!response.error) {
            dispatch(fetcheditMidSessionSuccess(response))
            dispatch(setEditSuccessMessage(true))
            setModalOpen(false)
            dispatch(getMidSession(setLoading))
            setLoading(false)
        }
    }).catch((errorResp) => { })
};